import { View } from "@/components/ui/view";
import { Text } from "@/components/ui/text";
import { Image } from "@/components/ui/image";
import { Box } from "@/components/ui/box";
import { Avatar, AvatarImage } from "@/components/ui/avatar";
import React, { useEffect } from "react";
import { ScrollView } from "react-native-gesture-handler";
import Footer from "@/components/basic/Footer";
import i18n from "i18n-js";
import { imageSrc } from "@/components/media/MediaSelector";
import { useSelector } from "react-redux";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useWindowDimensions } from 'react-native';


export default function StepTypeInformation({ navigation, route }) {
    const { step } = route.params
    const icons = useSelector((state) => state.icons)
    const insets = useSafeAreaInsets()
    const window = useWindowDimensions()

    useEffect(() => {
        if (step) {
            navigation.setOptions({ info: getInfoText(step.type) })
        }
    }, [step])

    const getInfoText = (type) => {
        switch (type) {
            case 0:
                return i18n.t('stepTypeInformation.do')
            case 1:
                return i18n.t('stepTypeInformation.fetch')
            case 2:
                return i18n.t('stepTypeInformation.wait')
            case 3:
                return i18n.t('stepTypeInformation.decide')
            default:
                return ''
        }
    }

    const getText = (type) => {
        switch (type) {
            case 0:
                return i18n.t('stepTypeInformation.doInfo')
            case 1:
                return i18n.t('stepTypeInformation.fetchInfo')
            case 2:
                return i18n.t('stepTypeInformation.waitInfo')
            case 3:
                return i18n.t('stepTypeInformation.decideInfo')
            default:
                return ''
        }
    }

    return (
        <View className="bg-secondary-50 flex-1">
            <ScrollView contentContainerStyle={{ paddingBottom: 70 + insets.bottom }}>
                <Image resizeMode='contain' key={step.type} source={imageSrc(icons.infos[step.type])} alt='StepType' className={` h-${window.width * 0.5} w-${window.width * 0.5} self-center `} />
                <View >
                    <Box className="border-2 border-white rounded-full absolute right-3 -top-7">
                        <Avatar size='md'>
                            <AvatarImage key={step.type} source={imageSrc(icons.types[step.type])} alt={i18n.t('global.missingImage')} className="border-2 border-primary-900 bg-secondary-50 z-100" />
                        </Avatar>
                    </Box>
                </View>
                <Text className="mx-3 mt-5 text-2xl leading-2xl text-secondary-900">{getText(step.type)}</Text>
            </ScrollView>
            <Footer navigation={navigation} />
        </View>
    );
}
